import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
const productDataIn = window.productData;
// import 'bootstrap/dist/css/bootstrap.css';

const NumberField = ({valueIn, index, changeState}) => {
  const [value, setValue] = useState(valueIn);
  const onChange = event => {
    const newValue = window.validateQty(event.target.value);
    setValue(newValue)
    changeState(index, newValue)
  };
  return (
     <select name="qty" id="qty" value={valueIn} onChange={onChange}>
      {[...Array(window.maxQty+1).keys()].map((value) => <option key={value} value={value}>{value}</option>)}
    </select>      
  );
};

const Items = ({items, onChange}) => {
  return items.map((item, index) => {
    return (
      <tr key={item.Key}>
        <td style={{border: "1px solid black"}} width="auto">
          <table>
            <tbody>
              <tr>
              <td><img src={item.Image} alt='item cover' width="auto"  height="auto"/></td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td colSpan="2"><a href={item.URL}>{item.Name}</a></td>
                    </tr>
                    <tr>
                      <td width="100">${item.Price.toFixed(2)}</td>
                      <td><NumberField valueIn={item.Qty} index={index} changeState={onChange}/></td>
                    </tr>
                  </tbody>
                </table>
              </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    )
  })
}

const Cart  = () => {
  const [productData, setProductData] = useState(productDataIn);
  const [calculatedState, setCalculatedState] = useState(window.storeAndCalculateState(productData));

  const updateState = () => {
    setProductData(productData);
    setCalculatedState(window.storeAndCalculateState(productData))
  }

  const handleChange = (index, value) => {
    productData[index].Qty = value;
    updateState();
  }

  const emptyCart = () => {
    window.emptyCart();
    updateState();
  }
  
  return (
    <>
      <table>
        <tbody>
          <Items items={productData} onChange={handleChange}/>
        </tbody>
      </table>
      <div style={{marginTop: "5px", marginLeft: "100px"}}>
        <span>
          <a href={calculatedState.qty===0 ? null : calculatedState.url}>
            <button disabled={calculatedState.qty===0} style={{color: calculatedState.qty===0 ? "gray" : "red"}}>
              Checkout
            </button>
          </a>
        </span>&nbsp;&nbsp;&nbsp;
        <span>
          <button disabled={calculatedState.qty===0} onClick={emptyCart} style={{color: calculatedState.qty===0 ? "gray" : "black"}}>
            Empty cart
          </button></span>&nbsp;&nbsp;&nbsp;
        <span>
          {calculatedState.totalPrice > 0 ? "$"+calculatedState.totalPrice.toFixed(2)+"+Shipping" : ""}
        </span>
      </div>
    </>
  )
}
/*
<p>{calculatedState.url}</p>
<input type="radio" id="us" name="location" value="us " />
<label htmlFor="us" style={{paddingRight: "5px"}}>US</label>
<input type="radio" id="canada" name="location" value="canada " />
<label htmlFor="canada" style={{paddingRight: "5px"}}>Canada</label>
<input type="radio" id="international" name="location" value="international " />
<label htmlFor="international" style={{paddingRight: "5px"}}>Other international</label>
*/
ReactDOM.render(
  <React.StrictMode>
    <Cart />
  </React.StrictMode>,
  document.getElementById('cart')
);
